import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import pick from 'lodash/pick';
import Link from 'shared/components/Link';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { injectIntl, intlShape } from 'react-intl';
import { urlReplaceSlash } from 'shared/modules';
import Select from 'react-select';
import onClickOutside from 'react-onclickoutside';
import REGIONS_CITIES from 'shared/constants/json/regions&cities.json';
import { directSetLocation } from 'shared/actions/globals';
import { sparesSetThunks, transportSetThunks } from 'shared/actions/searchForm';
import locationPointImg from 'shared/assets/images/placeholder-filled-point.svg';
import Loader from 'shared/components/Loader/Loader';
import {
  toLocalized,
  replaceRegion,
  setActiveLocations,
  getAllLocations,
} from 'shared/helpers/locale';
import { hrefSet } from 'shared/actions/partsForm';
import history from 'history.js';
import { compareByTitle } from 'shared/helpers/arrays';
import {
  generateDealersSearchUrl,
  generateFirmsSearchUrl,
  generateSearchQuery,
  generateSearchUrl,
  generateSparesSearchUrl,
} from 'shared/helpers/urls';
import OptionRenderer from './OptionRenderer/OptionRenderer';
import s from './LocationsBlock.css';

class LocationsBlock extends React.Component {
  static propTypes = {
    className: PropTypes.string.isRequired,
    locations: PropTypes.arrayOf(PropTypes.shape()),
    formState: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    partsForm: PropTypes.shape(),
    dispatch: PropTypes.func.isRequired,
    globals: PropTypes.shape(),
    location: PropTypes.shape(),
    routeName: PropTypes.string,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    globals: {},
    partsForm: {},
    className: '',
    locations: null,
    location: null,
    routeName: null,
  };

  state = {
    regionSelected: null,
    showLocationPopup: false,
    shouldInjectSecondaryLocations: false,
  };

  handleSelectInputChange = str => {
    this.setState({ shouldInjectSecondaryLocations: !!str });
  };

  handleListLocationSelect = location => {
    if (!this.state.regionSelected) this.setState({ regionSelected: location });
    else this.handleLocationChange(location);
  };

  handleLocationChange = location => {
    this.props.dispatch(directSetLocation(location));

    this.handleClickOutside();
    this.updateUrl(location);

    this.props.dispatch(transportSetThunks.count());
  };

  handleLocationButtonClick = () => {
    this.setState(({ showLocationPopup }) => ({ showLocationPopup: !showLocationPopup }));
  };

  handleClickOutside = () => this.setState({ showLocationPopup: false });

  stopPropagation = e => e.stopPropagation();

  refreshHomePage = location => {
    history.push(toLocalized(`/${location ? location.slug : ''}/`.replace(/\/\//g, '/')));
  };

  refreshMotoPage = location => {
    history.push(toLocalized(`/moto/${location ? location.slug : ''}/`.replace(/\/\//g, '/')));
  };

  refreshCommercialPage = location => {
    history.push(
      toLocalized(`/commercial/${location ? location.slug : ''}/`.replace(/\/\//g, '/')),
    );
  };

  refreshSearchPage = location => {
    const { formState, locale } = this.props;

    const state = { ...formState, location };
    const pathname = generateSearchUrl(state);
    const query = generateSearchQuery(state);

    history.push(toLocalized(`/${pathname}?${queryString.stringify(query)}`, locale));
  };

  refreshDealersPage = location => {
    const { formState, locale } = this.props;
    const state = { ...formState, location };
    const pathname = generateDealersSearchUrl(state);
    const query = generateSearchQuery(state);
    history.push(toLocalized(`/${pathname}?${queryString.stringify(query)}`, locale));
  };

  refreshFirmsPage = (location = {}) => {
    const {
      formState,
      locale,
      globals: { seoSearchUrlResponse },
      partsForm: {
        vocabulary: { query, queryobj },
      },
    } = this.props;
    const queryObj = { ...queryobj };
    const queryStr = `?${query}`;
    const state = { ...formState };
    const pathname = generateFirmsSearchUrl(state);
    if (
      !(
        seoSearchUrlResponse &&
        seoSearchUrlResponse.tag &&
        seoSearchUrlResponse.tag.slug &&
        seoSearchUrlResponse.kind === 'firms'
      )
    ) {
      return '';
    }
    if (location && location.slug) {
      this.props.dispatch(
        hrefSet({
          queryObj,
          url: toLocalized(
            `/${pathname}/${seoSearchUrlResponse.tag.slug}/${location.slug}`,
            locale,
          ),
        }),
      );
      return history.push(
        urlReplaceSlash(
          toLocalized(
            `/${pathname}/${seoSearchUrlResponse.tag.slug}/${location.slug}${
              query ? queryStr : ''
            }`,
            locale,
          ),
        ),
      );
    }
    if (queryObj.location) {
      delete queryObj.location;
    }
    this.props.dispatch(
      hrefSet({
        query: queryObj,
        url: toLocalized(`/${pathname}/${seoSearchUrlResponse.tag.slug}`, locale),
      }),
    );
    return history.push(
      urlReplaceSlash(
        toLocalized(
          `/${pathname}/${seoSearchUrlResponse.tag.slug}${
            query ? `?${queryString.stringify(queryObj)}` : '/'
          }`,
          locale,
        ),
      ),
    );
  };

  refreshSparesPage = location => {
    const { formState, locale } = this.props;
    const state = { ...formState, location };
    const pathname = generateSparesSearchUrl(state);
    const allParams = generateSearchQuery(state);
    const query = pick(allParams, [...Object.keys(sparesSetThunks), 'transport']);

    history.push(toLocalized(`/${pathname}?${queryString.stringify(query)}`, locale));
  };

  updateUrl = location => {
    const { routeName } = this.props;

    switch (routeName) {
      case 'home':
        this.refreshHomePage(location);
        break;
      case 'moto':
        this.refreshMotoPage(location);
        break;
      case 'commercial':
        this.refreshCommercialPage(location);
        break;
      case 'search':
        this.refreshSearchPage(location);
        break;
      case 'dealers':
        this.refreshDealersPage(location);
        break;
      case 'firms':
        this.refreshFirmsPage(location);
        break;
      case 'auto-parts':
        this.refreshSparesPage(location);
        break;

      default:
        break;
    }
  };

  handleClickRegionLink = () => {
    this.handleLocationChange(this.state.regionSelected);
  };

  render() {
    const {
      className,
      location,
      routeName,
      intl,
      locations,
      globals: { seoSearchUrlResponse },
    } = this.props;
    const { locations: seoLocations, location: selectedLocation } = seoSearchUrlResponse;
    const { regionSelected } = this.state;

    let formattedListLocations = regionSelected
      ? regionSelected.children.sort(compareByTitle)
      : locations;

    formattedListLocations = formattedListLocations
      .map(setActiveLocations(seoLocations, selectedLocation))
      .sort(compareByTitle);

    let formattedSelectLocations = [];

    if (regionSelected) {
      formattedSelectLocations = [regionSelected, ...regionSelected.children].map(
        setActiveLocations(seoLocations, selectedLocation),
      );
    } else {
      formattedSelectLocations = getAllLocations().map(
        setActiveLocations(seoLocations, selectedLocation),
      );
    }

    const titleKey = intl.formatMessage({ id: 'locale' }) === 'uk' ? 'uk_title' : 'title';

    return (
      <div className={cx(s.root, className)} onClick={this.handleLocationButtonClick}>
        <img src={locationPointImg} className={s.locationPointImg} width="14" alt="" />{' '}
        <span className={s.label}>
          {location && location.title
            ? intl.formatMessage({ id: location.title })
            : intl.formatMessage({ id: 'Вся Украина' })}
        </span>
        <ReactCSSTransitionGroup
          transitionName="fadeUp"
          transitionEnterTimeout={100}
          transitionLeaveTimeout={100}
        >
          {this.state.showLocationPopup && (
            <div className={s.popupBlock} onClick={this.stopPropagation}>
              <div className={s.inputBlock}>
                <div className={s.buttonsBlock}>
                  {!!regionSelected && (
                    <Link
                      className={cx(s.linkItem, s.backLink)}
                      onClick={() => this.setState({ regionSelected: null })}
                    >
                      <span className={cx(s.linkItemArrow, s.backArrow)} />
                      {intl.formatMessage({ id: 'Изменить' })} область
                    </Link>
                  )}
                  <Link
                    className={cx(s.linkItem, s.regionLink)}
                    onClick={this.handleClickRegionLink}
                  >
                    {intl.formatMessage({
                      id: regionSelected ? 'Искать по всей области' : 'Вся Украина',
                    })}
                  </Link>
                </div>
                <div key="1" className={s.list}>
                  <Loader isLoading={!locations}>
                    <Select
                      className={s.select}
                      options={formattedSelectLocations}
                      placeholder={`${intl.formatMessage({ id: 'Выберите город' })}...`}
                      labelKey={titleKey}
                      valueKey="id"
                      value={location}
                      onChange={this.handleLocationChange}
                      onInputChange={this.handleSelectInputChange}
                      optionRenderer={option => <OptionRenderer {...option} />}
                      isDisabled={option => option.disabled}
                      matchPos="start"
                      openOnFocus
                    />
                  </Loader>
                </div>
              </div>
              <div className={s.locationsBlock}>
                <ul>
                  {formattedListLocations.map(item => (
                    <li key={item.id}>
                      <Link
                        disabled={item.disabled}
                        className={s.linkItem}
                        onClick={() => this.handleListLocationSelect(item)}
                      >
                        <span>{replaceRegion(item[titleKey] || item.title)}</span>
                        {!regionSelected && <span className={s.linkItemArrow} />}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

const mapStateToProps = ({ globals, history: historyState, searchForm, partsForm }) => ({
  locations: searchForm.vocabulary.locations
    ? searchForm.vocabulary.locations[0].children
    : REGIONS_CITIES,
  location: globals.location,
  locale: globals.locale,
  routeName: historyState.currentRouteName,
  formState: searchForm && searchForm.selected,
  partsForm,
  globals,
});

const mapDispatchToProps = dispatch => ({ dispatch });

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(injectIntl(onClickOutside(LocationsBlock))),
);



// WEBPACK FOOTER //
// ./src/desktop/components/LocationsBlock/LocationsBlock.js